import { createContext, useContext, ReactNode } from 'react';
import { DateRange } from 'react-day-picker';
import { useDateRangeControls } from '@/Domain/hooks/Analytics/useDateRangeControls.hook';
import { DateRangeState } from '@/Domain/types/DateRange.types';

type DateRangeContextType = {
  range: DateRangeState;
  handleRangeChange: (range: DateRange | undefined) => void;
};

const DateRangeContext = createContext<DateRangeContextType | undefined>(undefined);

type Props = {
  children: ReactNode;
};

export const DateRangeProvider = ({ children }: Props) => {
  const { range, handleRangeChange } = useDateRangeControls();

  return (
    <DateRangeContext.Provider
      value={{
        range,
        handleRangeChange,
      }}
    >
      {children}
    </DateRangeContext.Provider>
  );
};

export const useDateRange = () => {
  const context = useContext(DateRangeContext);
  if (context === undefined) {
    throw new Error('useDateRange must be used within a DateRangeProvider');
  }
  return context;
};
